// extracted by mini-css-extract-plugin
module.exports = {"button":"_6eb00b8e53--button--1OnbY","spinner":"_6eb00b8e53--spinner--3kgUG"};